import React from 'react'
import Hero from '../Components/Hero'

const About = () => {
  return (
    <section >
        <Hero/>
    </section>
  )
}

export default About